export enum EHonestWorkIconSize {
  Big = 'big',
  Small = 'small',
}
